import { useEffect, useRef } from 'react';

// Screens inside a card (a person's connects, a holdings list) register here so the stepper's
// Back button closes them first, innermost first, instead of leaving the card.
const handlers = [];

/** Called by the stepper's Back: true when an inner screen handled (closed) itself. */
export const handleInnerBack = () => {
  const top = handlers[handlers.length - 1];
  if (!top) return false;
  top.current();
  return true;
};

/** While `active`, Back calls `onBack` instead of moving to the previous card. */
export const useInnerBack = (active, onBack) => {
  const ref = useRef(onBack);
  ref.current = onBack;
  useEffect(() => {
    if (!active) return undefined;
    handlers.push(ref);
    return () => {
      const index = handlers.lastIndexOf(ref);
      if (index >= 0) handlers.splice(index, 1);
    };
  }, [active]);
};
